import { m } from 'framer-motion'
// components
import Page from '../../components/Page'
// assets
import SeverErrorIllustration from '../../assets/illustration_500'

// ----------------------------------------------------------------------

export default function Page500() {
    const goBack = () => {
        window.history.back()
        window.location.reload()
    }

    const goHome = () => {
        window.location = '/'
    }
    return (
        <Page title='500 Internal Server Error'>
            <div className="container mx-auto">
                <div className="max-w-lg mx-auto min-h-screen flex flex-col justify-center items-center py-12 px-4 text-center">
                    <m.div>
                        <h1 className="text-3xl font-bold mb-4">
                            500 Internal Server Error
                        </h1>
                    </m.div>

                    <m.div>
                        <p className="text-gray-600 mb-8">
                            There was an error, please try again later.
                        </p>
                    </m.div>

                    <m.div>
                        <SeverErrorIllustration className="h-64 my-8 md:my-10" />
                    </m.div>
                    
                    <div className="flex flex-row justify-center items-center space-x-4">
                        <button
                            onClick={goBack}
                            className="px-6 py-2 border border-gray-300 text-gray-700 font-medium rounded-md hover:bg-gray-50 transition-colors"
                        >
                            Go Back
                        </button>
                        <button
                            onClick={goHome}
                            className="px-6 py-2 border border-gray-300 text-gray-700 font-medium rounded-md hover:bg-gray-50 transition-colors"
                        >
                            Go to Home
                        </button>
                    </div>
                </div>
            </div>
        </Page>
    )
}
